import { Chip } from '@heroui/react';
import { TransactionAmount } from './TransactionAmount';

type TransactionDiscountAmountProps = { amountTetri: number };

export const TransactionDiscountAmount = ({
    amountTetri,
}: TransactionDiscountAmountProps) => (
    <Chip color="default" variant="tertiary" size="sm" className="shrink-0">
        <Chip.Label>
            <TransactionAmount amountTetri={amountTetri} minus />
        </Chip.Label>
    </Chip>
);
